'use client';

import type { ILevelStats } from '@repo/sdk';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  type ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@repo/ui';
import type { JSX } from 'react';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';

const config: ChartConfig = {
  total: { label: 'Challenges', color: 'var(--chart-1)' },
};

export function LevelsChart({ levels }: { levels: Record<string, ILevelStats> }): JSX.Element {
  const data = Object.values(levels)
    .sort((a, b) => a.level - b.level)
    .map((l) => ({ name: `L${l.level}`, total: l.total }));

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Mastery Levels</CardTitle>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <div className="text-muted-foreground py-8 text-center text-sm">No data yet</div>
        ) : (
          <ChartContainer config={config} className="h-[240px] w-full">
            <BarChart data={data} margin={{ top: 4, right: 8, bottom: 0, left: 0 }}>
              <defs>
                <linearGradient id="fill-levels" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="var(--color-total)" stopOpacity={0.9} />
                  <stop offset="100%" stopColor="var(--color-total)" stopOpacity={0.35} />
                </linearGradient>
              </defs>
              <CartesianGrid vertical={false} strokeDasharray="3 3" className="stroke-border/30" />
              <XAxis dataKey="name" tickLine={false} axisLine={false} tickMargin={8} />
              <YAxis width={28} tickLine={false} axisLine={false} allowDecimals={false} />
              <ChartTooltip content={<ChartTooltipContent />} />
              <Bar dataKey="total" fill="url(#fill-levels)" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
}
